import { Navigate } from "react-router-dom";
import useAuthStore from "../../store/auth.store";

// Route guard for org-only features. Backend enforces real auth; this is
// defense-in-depth so a B2C user who guesses a deep-link doesn't see the
// page chrome flash before the in-page gate kicks in.
//
// Redirects unauthorised users to /dashboard silently.
export default function RequireOrg({ children }) {
  const { user, isAuthenticated, loading } = useAuthStore();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!user?.organization_id) return <Navigate to="/dashboard" replace />;
  return children;
}
